export default __webpack_public_path__ + "static/media/desktop.964ebd4d.svg";